import { useApp }  from '../../../app/AppContext.jsx'
import { useI18n } from '../../i18n/useI18n.js'

import { Tooltip }          from '../Tooltip/index.js'
import { BimCadaplusLogo }  from '../BimCadaplusLogo/index.js'

import styles from './BimCadaplusLogoTag.module.scss'

const POSITION_CLASS = {
  top:    styles.posTop,
  bottom: styles.posBottom,
  left:   styles.posLeft,
  right:  styles.posRight,
}

const SIZE_CLASS = {
  small:  styles.sizeSmall,
  medium: styles.sizeMedium,
  large:  styles.sizeLarge,
}

const MOBILE_CLASS = {
  true: styles.mobile,
  false: '',
}

/**
 * BimCadaplusLogoTag — BimCadaplusLogo inside a tag-shaped background pill.
 *
 * Two corners are rounded based on `position`: the corners that face away from
 * the edge the tag is attached to remain rounded; the edge-side corners are
 * flush (border-radius 0). Uses `--bim-shape-tag` CSS variable.
 *
 * Placement on the page is the parent's responsibility.
 *
 * Shows a Tooltip crediting BIM.CADAPLUS.COM and optionally the developer.
 *
 * @param {'small'|'medium'|'large'} [props.size='medium']
 *   The size of the tag. Determines the padding and the logo size. Uses CSS variables:
 * @param {'top'|'bottom'|'left'|'right'} [props.position='bottom']
 *   Which edge the tag is attached to. Determines which 2 corners are rounded.
 * @param {string}  [props.className]  Extra class applied to the tag wrapper.
 * @param {boolean} [props.isMobile]  Whether the tag is being displayed on a mobile device.
 */
export function BimCadaplusLogoTag({ size = 'medium', position = 'bottom', className, isMobile }) {
  const { projectConfig } = useApp()
  const { t }             = useI18n()

  const developerName = projectConfig?.developer_display_name ?? null

  const tooltipTitle = developerName
    ? t('common.bim_logo_tooltip_developer', { developer: developerName })
    : t('common.bim_logo_tooltip')

  const posClass = POSITION_CLASS[position] ?? styles.posBottom
  const sizeClass = SIZE_CLASS[size] ?? styles.sizeMedium

  return (
    <Tooltip title={tooltipTitle} placement="top" disableOnMobile={false}>
      <div className={[styles.tag, posClass, sizeClass, MOBILE_CLASS[isMobile], className].filter(Boolean).join(' ')}>
        <BimCadaplusLogo />
      </div>
    </Tooltip>
  )
}